var _rect, _polyline, _polyline2, _polyline3, _polyline4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPiechartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 650,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 1000 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 650,
    x: 0,
    y: 0,
    id: 0,
    fill: "#FFFFFF"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "718.6 154.8 729.9 145 744.9 145",
    fill: "none",
    stroke: "#009bd7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "658 587.9 666.2 600.4 681.2 600.4",
    fill: "none",
    stroke: "#f0a82d"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "237.6 467.9 224 474.2 209 474.2",
    fill: "none",
    stroke: "#e95000"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "342 102.1 333.8 89.6 318.8 89.6",
    fill: "none",
    stroke: "#af46a8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 55.25A289.75 289.75 0 0 1 786.9562 385.1398L500 345Z",
    fill: "#009bd7",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M786.9562 385.1398A289.75 289.75 0 0 1 420.4944 623.6287L500 345Z",
    fill: "rgb(240,168,45)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420.4944 623.6287A289.75 289.75 0 0 1 235.072 227.6619L500 345Z",
    fill: "rgb(233,80,0)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.072 227.6619A289.75 289.75 0 0 1 500 55.25L500 345Z",
    fill: "#af46a8",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(749.9331 144.9916)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Premiere_Year"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(686.2266 600.4237)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Seasons"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(204.0113 474.2393)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Episodes"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(313.7734 89.5763)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "IMDB_Rating"), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l410.9 0l0 26l-410.9 0Z",
    transform: "translate(299.55 25)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(300.55 26)",
    fill: "#009bd7",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(300.55 26)",
    fill: "#333"
  }, "Premiere_Year"), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(421.1167 26)",
    fill: "#f0a82d",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(421.1167 26)",
    fill: "#333"
  }, "Seasons"), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(508.7833 26)",
    fill: "#e95000",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(508.7833 26)",
    fill: "#333"
  }, "Episodes"), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(599.1167 26)",
    fill: "#af46a8",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(599.1167 26)",
    fill: "#333"
  }, "IMDB_Rating"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechartThumb);
export default __webpack_public_path__ + "static/media/piechart_thumb.10c7083f8303fc781f915abcb2cae5df.svg";
export { ForwardRef as ReactComponent };